/* eslint-disable max-len */
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import { URLS } from '../../errorTextsConstants';
import {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCOMPATIBLE_PRODUCT: {
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte este producto',
          msg: [
            'Es necesario tener una línea móvil Movistar.',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Ver tarifas móviles',
            link: URLS.MOBILE_TARIFF_LIST,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      },
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya tienes MultiSIM',
          msg: [
            'Ya tienes MultiSIM en el número que has seleccionado',
            'Si tu contrato incluye la MultiSIM a 0€/mes solicítala aquí.'
          ],
          errorName: "Producto ya contratado.",
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Solicitar MultiSIM a 0€/mes',
            link: 'https://www.movistar.es/form/cliente/multisim',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      },
      BLOCKED_USER: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Lo sentimos, no podemos continuar con tu pedido online',
          msg: [
            'Por seguridad en la compra y recogida de este producto debes ir a una tienda Movistar.',
            'Si lo deseas, puedes pedir una cita previa en tienda para realizarlo.',
          ],
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              onClick: () => {
                window.location.href = URLS.BOOK_SHOP_APPOINTMENT;
              },
              label: 'Solicitar cita previa',
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.MEDIUM,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
            {
              color: BUTTON_COLOR.BLUE_REVERSE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'passport user blocked',
        },
      }
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
